export default "__VITE_ASSET__cc50108e__"